import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="header"
export default class extends Controller {
  static targets = ["menu", "backdrop", "burger", "submenu", "submenuIcon"]
  static values = { open: Boolean }

  connect() {
    this.openValue = false
  }

  toggle() {
    this.openValue = !this.openValue
    this.updateMenu()
  }

  close() {
    this.openValue = false
    this.updateMenu()
  }

  updateMenu() {
    if (this.openValue) {
      this.openMenu()
    } else {
      this.closeMenu()
    }
  }

  openMenu() {
    // Show backdrop and menu
    this.backdropTarget.classList.remove("invisible", "opacity-0")
    this.backdropTarget.classList.add("opacity-50")
    this.menuTarget.classList.remove("-translate-x-full")
    this.menuTarget.classList.add("translate-x-0")

    // Animate burger to X
    this.burgerTarget.classList.add("open")

    // Lock body scroll
    document.body.classList.add("overflow-hidden")
  }

  closeMenu() {
    // Hide backdrop and menu
    this.backdropTarget.classList.add("opacity-0")
    this.backdropTarget.classList.remove("opacity-50")
    this.menuTarget.classList.add("-translate-x-full")
    this.menuTarget.classList.remove("translate-x-0")

    // Animate X to burger
    this.burgerTarget.classList.remove("open")

    // Unlock body scroll
    document.body.classList.remove("overflow-hidden")

    // Delay hiding backdrop until transition completes
    setTimeout(() => {
      if (!this.openValue) {
        this.backdropTarget.classList.add("invisible")
      }
    }, 300)
  }

  toggleSubmenu(event) {
    const button = event.currentTarget
    const index = this.submenuTargets.indexOf(
      button.nextElementSibling
    )

    if (index === -1) return

    const submenu = this.submenuTargets[index]
    const icon = this.submenuIconTargets[index]

    if (submenu.classList.contains("hidden")) {
      // Expand
      submenu.classList.remove("hidden")
      submenu.style.maxHeight = submenu.scrollHeight + "px"
      icon.textContent = "−"
    } else {
      // Collapse
      submenu.style.maxHeight = "0px"
      icon.textContent = "+"
      // Hide after animation
      setTimeout(() => {
        submenu.classList.add("hidden")
      }, 200)
    }
  }

  // Close menu when clicking a navigation link
  navigate() {
    this.close()
  }

  // Close menu on escape key
  closeOnEscape(event) {
    if (event.key === "Escape" && this.openValue) {
      this.close()
    }
  }
}
